/** API route map: URLS.Controller.EmployeeTaxSetting */
export const EmployeeTaxSetting = {
      Name: 'EmployeeTaxSetting/',
      PatchTaskStatus: 'patch-setting',
      UpdateTaxSetting: 'update-setting',
      Get: 'get',
};
